import { apiRequest } from '@/core';
import { type UploadFileRequest, type UploadFileResponse } from '@/types';

export const uploadFileRequest = async ({
  formData,
  propertyId,
}: UploadFileRequest) =>
  apiRequest<UploadFileResponse>({
    endpoint: `api/files/upload/${propertyId}`,
    method: 'POST',
    body: formData,
  });
